import { GenericPanelData } from 'features/drilldown/types'
import {
  EnrichedOntologyFieldDefinition,
  OntologyField,
  OntologyFieldType,
} from 'features/dynamicOntology'

export type ListFilterMatchMode = 'include' | 'exclude'

export interface ValueListFilterPanelData extends GenericPanelData {
  matchField: OntologyField
  /** Shown in brackets beside each candidate value. Empty to show none. */
  secondaryField: OntologyField
  matchMode: ListFilterMatchMode
  shouldSuggestFuzzyMatches: boolean
  /** Display only — the raw value is still what the filter is built from. */
  shouldUppercaseValues: boolean
  pastedText: string
  /** Keyed by normalized term so a user's disambiguation survives a reload. */
  chosenValuesByTerm: Record<string, ReadonlyArray<string>>
}

const LATEST_DATA_SCHEMA_VERSION = 1

/** Field types a pasted list of values can meaningfully be matched against. */
export const MATCHABLE_FIELD_TYPES: ReadonlyArray<OntologyFieldType> = [
  'text',
  'number',
  'enum',
]

/**
 * A secondary value has to come off the same entry as the matched value:
 * grouping across a link fans one match value out over many secondary values,
 * leaving no single one to show.
 */
export function isPairableSecondaryField(
  matchFieldDef: EnrichedOntologyFieldDefinition | undefined,
  secondaryFieldDef: EnrichedOntologyFieldDefinition | undefined
): boolean {
  return (
    !!matchFieldDef &&
    !!secondaryFieldDef &&
    secondaryFieldDef.entryType === matchFieldDef.entryType &&
    secondaryFieldDef.key !== matchFieldDef.key
  )
}

export const DEFAULT_VALUE_LIST_FILTER_PANEL_DATA: ValueListFilterPanelData = {
  panelDataSchemaVersion: LATEST_DATA_SCHEMA_VERSION,
  title: 'Value List Filter',
  isPinned: false,
  matchField: 'unit.id',
  secondaryField: 'unit.description',
  matchMode: 'include',
  shouldSuggestFuzzyMatches: true,
  shouldUppercaseValues: true,
  pastedText: '',
  chosenValuesByTerm: {},
}
